import axios from "axios";
import _ from "lodash";
import { getAccessToken } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
export const FETCH_SEARCH_DATA = "FETCH_SEARCH_DATA";
export const UPDATE_PUBLIC_FILTERS = "UPDATE_PUBLIC_FILTERS";
export const TOGGLE_SEARCH_FILTERS_SHOW = "TOGGLE_SEARCH_FILTERS_SHOW";
export const SAVE_SEARCH_DATA_PARAMS = "SAVE_SEARCH_DATA_PARAMS";
export const CREATE_QUERY = "CREATE_QUERY";
var moment = require("moment");
const revMapSubType = {
    "person-male": "male",
    "person-female": "female",
    "person-unknown": "unknown",
    "non-person-news": "news",
    "non-person-brand": "brand",
    "non-person-unknown": "unknown",
};

export function fetchSearchData(data, searchDataType) {
    let params = new URLSearchParams();
    params.append("offset", data.offset);
    if (searchDataType != 1) {
        params.append("duration", data.duration);
    }
    if (searchDataType == 1) {
        params.append("public_data", "1");
    }
    params.append("data", data.data);
    params.append("custom_query", data.custom_query);
    params.append("recordsPerPage", data.recordsPerPage);
    //console.log(params); return false;

    return function (dispatch) {
        dispatch({ type: UPDATE_PUBLIC_FILTERS, payload: data, searchDataType: searchDataType });
        let api_url = "";
        if (searchDataType == 1) {
            api_url = "https://20twentystage.circussocial.com/v7/search?access-token=" + getAccessToken();
            //api_url = getUrl('raw_data');
        } else {
            api_url = getUrl("raw_data");
        }
        dispatch({
            type: "FETCH_SEARCH_DATA_PENDING",
        });
        axios
            .post(api_url, params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                // console.log(response);
                dispatch({
                    type: "FETCH_SEARCH_DATA_FULFILLED",
                    payload: response.data,
                    offset: data.offset,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };
}

export function saveSearchDataParams(searchDataType, custom_query) {
    return function (dispatch) {
        dispatch({
            type: "SAVE_SEARCH_DATA_PARAMS",
            searchDataType: searchDataType,
            custom_query: custom_query,
        });
    };
}

export function fetchSearchFilterData(params) {
    return function (dispatch) {
        //dispatch({ type: UPDATE_PUBLIC_FILTERS, payload: data, searchDataType: searchDataType });
        let api_url = getUrl("raw_data");
        dispatch({
            type: "FETCH_SEARCH_DATA_PENDING",
        });
        axios
            .post(api_url, params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                // console.log(response);
                dispatch({
                    type: "FETCH_SEARCH_DATA_FULFILLED",
                    payload: response.data,
                    offset: 1,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };
}

export function toggleSearchFiltersShow(show) {
    return {
        type: TOGGLE_SEARCH_FILTERS_SHOW,
        payload: show,
    };
}

export const getSearchFilterReqParams = (filters_info, sortOption, influencers, sentiment, sentimentType, media, channel, postType, exclusion, sampling) => {
    // console.log("filters_info",filters_info);
    let params = new URLSearchParams();
    let filterOptions = JSON.parse(localStorage.getItem("filterOptions"));

    //locations

    if (filters_info.all_locations_selected || !filters_info.locations_selected.length) {
        params.append("location", filterOptions.countries.map((elem) => elem.id).join(","));
    } else if (filters_info.locations_selected.length) {
        params.append("location", filters_info.locations_selected.join(","));
    }

    //languages

    if (filters_info.all_languages_selected || !filters_info.languages_selected.length) {
        params.append("language", filterOptions.languages.map((elem) => elem.id).join(","));
    } else if (filters_info.languages_selected.length) {
        params.append("language", filters_info.languages_selected.join(","));
    }

    //platforms

    if (filters_info.all_platforms_selected || !filters_info.platforms_selected.length) {
        params.append("platform", filterOptions.platforms.map((elem) => elem.id).join(","));
    } else if (filters_info.platforms_selected.length) {
        params.append("platform", filters_info.platforms_selected.join(","));
    }

    //duration

    if (filters_info.duration !== "custom" && filters_info.duration !== "24HRS") {
        params.append("duration", filters_info.duration);
    } else if (filters_info.duration === "custom") {
        if (filters_info.rollingDate) {
            params.append("start_date", moment(filters_info.startDateTime).format("YYYY-MM-DDTHH:mm:ss"));
            params.append("end_date", moment().format("YYYY-MM-DDTHH:mm:ss"));
        } else {
            params.append("start_date", moment(filters_info.startDateTime).format("YYYY-MM-DDTHH:mm:ss"));
            params.append("end_date", moment(filters_info.endDateTime).format("YYYY-MM-DDTHH:mm:ss"));
        }
    } else {
        params.append("start_date", moment(moment().unix() * 1000 - 24 * 60 * 60 * 1000).format("YYYY-MM-DDTHH:mm:ss"));
        params.append("end_date", moment(moment().unix() * 1000).format("YYYY-MM-DDTHH:mm:ss"));
    }

    //entity type

    let entity_param = [];
    if (filters_info.entities_selected.length) {
        filters_info.entities_selected.forEach((elem) => {
            entity_param.push(`(post.entity_type:${elem})`);
        });
    }
    if (!_.isEmpty(filters_info.sub_entities_selected)) {
        for (var elem in filters_info.sub_entities_selected) {
            if (filters_info.sub_entities_selected[elem].length) {
                let temp = `(post.entity_type:${elem} AND (`;
                for (var i = 0; i < filters_info.sub_entities_selected[elem].length - 1; i++) {
                    temp += `post.entity_sub_type:${revMapSubType[filters_info.sub_entities_selected[elem][i]]} OR `;
                }
                temp += `post.entity_sub_type:${revMapSubType[filters_info.sub_entities_selected[elem][i]]}))`;
                entity_param.push(temp);
            }
        }
    }
    if (entity_param.length) {
        params.append("entity_boolean", entity_param.join(" OR "));
    }

    //topic data

    let topics = [];
    if (filters_info.topics_selected.length || !_.isEmpty(filters_info.subtopics_selected)) {
        for (i = 0; i < filters_info.topics_selected.length; i++) {
            let children = filterOptions.topics.filter((elem) => elem.topic_id === filters_info.topics_selected[i]);
            let subtopicIds = children.map((elem) => elem.subtopic_id);
            let subtopicNames = [];
            subtopicIds.forEach((element) => {
                subtopicNames.push({ id: element, name: filterOptions.topics.find((elem) => elem.subtopic_id === element).subtopic_name });
            });
            topics.push({
                topic_id: filters_info.topics_selected[i],
                name: filterOptions.topics.find((elem) => elem.topic_id === filters_info.topics_selected[i]).topic_name,
                subtopicIds,
                subtopicNames,
            });
        }
        for (var obj in filters_info.subtopics_selected) {
            if (filters_info.subtopics_selected[obj].length) {
                let subtopicNames = [];
                filters_info.subtopics_selected[obj].forEach((element) => {
                    subtopicNames.push({ id: element, name: filterOptions.topics.find((elem) => elem.subtopic_id === element).subtopic_name });
                });
                topics.push({
                    topic_id: obj,
                    name: filterOptions.topics.find((elem) => elem.topic_id === obj).topic_name,
                    subtopicIds: filters_info.subtopics_selected[obj],
                    subtopicNames,
                });
            }
        }
    }

    if (!topics.length) {
        let topics_available = [];
        let i;
        for (i = 0; i < filterOptions.topics.length; i++) {
            if (!topics_available.includes(filterOptions.topics[i].topic_id)) {
                topics_available.push(filterOptions.topics[i].topic_id);
            }
        }
        for (i = 0; i < topics_available.length; i++) {
            let children = filterOptions.topics.filter((elem) => elem.topic_id === topics_available[i]);
            let subtopicIds = children.map((elem) => elem.subtopic_id);
            let subtopicNames = [];
            subtopicIds.forEach((element) => {
                subtopicNames.push({ id: element, name: filterOptions.topics.find((elem) => elem.subtopic_id === element).subtopic_name });
            });
            topics.push({
                topic_id: topics_available[i],
                name: filterOptions.topics.find((elem) => elem.topic_id === topics_available[i]).topic_name,
                subtopicIds,
                subtopicNames,
            });
        }
        params.append("topic_data", JSON.stringify(topics));
    } else {
        params.append("topic_data", JSON.stringify(topics));
    }
    //publications

    if (filters_info.all_publications_selected) {
        params.append("fields_exist", "publications");
    }
    if (filters_info.untagged_publications) {
        params.append("fields_not_exist", "publications");
    }
    if (filters_info.other_tagged_publications) {
        params.append("publications_not_in", filterOptions.publications.map((elem) => elem.name).join(","));
    }
    if (filters_info.publications_selected.length) {
        params.append("publications", filters_info.publications_selected.join(","));
    }

    // custom_query
    if (filters_info.custom_query && filters_info.custom_query.length) {
        params.append("custom_query", filters_info.custom_query);
    }

    // sort option
    if (sortOption === "published_date_desc") {
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
    } else if (sortOption === "published_date_asc") {
        params.append("orderBy", "post.published_date");
        params.append("order", "asc");
    } else if (sortOption === "impact_prediction_score") {
        // virality score more than 300
        params.append("orderBy", "impact_prediction_score");
    } else if (sortOption === "trending_now_virality") {
        // virality score more than 300
        params.append("virality_parameter", 0);
        params.append("orderBy", "impact_value");
    } else if (sortOption === "predicted_virality") {
        // virality score more than 300
        params.append("virality_parameter", 1);
        params.append("orderBy", "impact_prediction_score");
    } else params.append("orderBy", sortOption);

    params.append("offset", "1");
    params.append("data", "1");
    params.append("recordsPerPage", 50);

    // refine filter
    if (sentiment !== "ALL") params.append("sentiment", sentiment);
    if (sentimentType !== "ALL") params.append("sentiment_source", sentimentType);
    if (media !== "ALL") params.append("post_media_type", media);

    if (channel !== "ALL") params.append("source_type", channel);

    if (postType !== "ALL") params.append("post_type", postType);

    return params;
};

export function createQueryFunc(data) {
    let access_token = getAccessToken();
    let params = new URLSearchParams();
    params.append("company_identifier", data.company_identifier);
    params.append("boolean_query", data.boolean_query);
    params.append("countries", data.countries);
    params.append("data_fetch_enabled", data.data_fetch_enabled);
    params.append("graph_color", data.graph_color);
    params.append("name", data.name);
    params.append("status", data.status);
    params.append("subtopic", data.subtopic);
    params.append("subtopic_graph_color", data.subtopic_graph_color);
    params.append("twitter_stream_query", data.twitter_stream_query);
    params.append("user_id", data.user_id);
    params.append("access-token", access_token);
    return function (dispatch) {
        //dispatch({ type: UPDATE_PUBLIC_FILTERS, payload: data, searchDataType: searchDataType });
        let api_url = getUrl("query_builder");
        // console.log(api_url);
        axios
            .post(api_url, params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "CREATE_QUERY_FULFILLED",
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };
}
